// extracted by mini-css-extract-plugin
module.exports = {"invoiceCompanyListSelectedCompany":"InvoiceCompanyList_invoiceCompanyListSelectedCompany_2WCPa"};